import { ReactNode } from "react";

import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import { ApiKeyRolesBulkActionsAnalyticsPayload, ApiKeyRolesBulkActionsSelectedAction } from "../types";
import ApiKeyRolesBulkActionsConfirmActionStepDefault from "./Default";
import { ApiKeyRolesBulkActionsConfirmActionStepProps } from "./types";
import { ApiKeyRolesMutationVariables } from "../useApiKeyRolesBulkActions/types";

type ApiKeyRolesBulkActionsConfirmActionFormProps = {
  action: ApiKeyRolesBulkActionsSelectedAction;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: ApiKeyRolesMutationVariables,
    analyticsPayload: ApiKeyRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const ApiKeyRolesBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: ApiKeyRolesBulkActionsConfirmActionFormProps) => {
  const props: ApiKeyRolesBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
    customConfirmationMessage,
  };

  const actionComponent = <ApiKeyRolesBulkActionsConfirmActionStepDefault {...props} />;

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default ApiKeyRolesBulkActionsConfirmActionForm;